import { useState } from "react";
import { MERGE_PATCH_HEADER } from "@constants";
import { dismissNotificationRoute } from "@api-routes";
import { useFetch } from "@common/hook/useFetch";

export const useAlert = (alertId: number, getAlertList: () => Promise<void>) => {
    const [isLoading, setIsLoading] = useState(false);
    const [removeAlertState, { patch }] = useFetch();

    const removeAlert = (): void => {
        setIsLoading(true);

        patch<boolean>(dismissNotificationRoute(alertId), {
            headers: MERGE_PATCH_HEADER,
        }).then((result) => {
            if (result) {
                getAlertList().then(() => setIsLoading(false));
            } else {
                setIsLoading(false);
            }
        });
    };

    return { removeAlert, removeAlertState, isLoading };
};
